function Initializer(usePerfMonior:boolean = true):void {
	addPolyfills();
	GlobalErrorListener.init();
	window.onerror = ChainerSync.chain(window, window.onerror, function (msg:string, url:string, line:number, col?:number, error?:any):boolean {
		GlobalErrorListener.onGlobalError.emit(msg, url, line, col, error);
		return GlobalErrorListener.isOutputSupressed();
	});

	HTMLUtils.init();
	window.onresize = ChainerSync.chain(window, window.onresize, function():void{
		HTMLUtils.onWindowResize.emit();
	});

	
	initSocialInfo();
	PandaConsole.$INIT();
	Stat.intance =  new Stat(new URI('').protocol(location.protocol).host('stat.crazypanda.ru').path('event'), 100);
	GlobalInstanceChecker.check();
	MainLoop.init(usePerfMonior);
}

function addPolyfills() {
	if (!Date.prototype.toISOString) {
		(function() {
			function pad(val:any) {
				if (val < 10) {
					return '0' + val;
				}
					return val;
				}

				Date.prototype.toISOString = function() {
				return this.getUTCFullYear() +
				'-' + pad(this.getUTCMonth() + 1) +
				'-' + pad(this.getUTCDate()) +
				'T' + pad(this.getUTCHours()) +
				':' + pad(this.getUTCMinutes()) +
				':' + pad(this.getUTCSeconds()) +
				'.' + (this.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) +
				'Z';
			};
		}());
	}
	if (!Array.prototype.filter) {
		Array.prototype.filter = function(fun:Function/*, thisArg*/) {
			'use strict';

			if (this === void 0 || this === null) {
				throw new TypeError();
			}

			var t = Object(this);
			var len = t.length >>> 0;
			if (typeof fun !== 'function') {
				throw new TypeError();
			}

			var res = new Array<any>();
			var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
			for (var i = 0; i < len; i++) {
				if (i in t) {
					var val = t[i];

					// NOTE: Technically this should Object.defineProperty at
					//       the next index, as push can be affected by
					//       properties on Object.prototype and Array.prototype.
					//       But that method's new, and collisions should be
					//       rare, so use the more-compatible alternative.
					if (fun.call(thisArg, val, i, t)) {
						res.push(val);
					}
				}
			}
			return res;
		}
	}
	if (!Array.prototype.indexOf) {
	  Array.prototype.indexOf = function Array_indexOf(elt /*, from*/)
	  {
	    var len = this.length >>> 0;
	    var from = Number(arguments[1]) || 0;
	    from = (from < 0)
	         ? Math.ceil(from)
	         : Math.floor(from);
	    if (from < 0)
	      from += len;

	    for (; from < len; from++)
	    {
	      if (from in this &&
	          this[from] === elt)
	        return from;
	    }
	    return -1;
	  };
	}
	//https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce
	// Production steps of ECMA-262, Edition 5, 15.4.4.21
	// Reference: http://es5.github.io/#x15.4.4.21

	if (!Array.prototype.reduce) {
	  Array.prototype.reduce = function Array_reduce(callback:Function /*, initialValue*/) {
	    'use strict';
	    if (this === null) {
	      throw new TypeError('Array.prototype.reduce called on null or undefined');
	    }
	    if (typeof callback !== 'function') {
	      throw new TypeError(callback + ' is not a function');
	    }
	    var t = Object(this), len = t.length >>> 0, k = 0, value:any;
	    if (arguments.length == 2) {
	      value = arguments[1];
	    } else {
	      while (k < len && !(k in t)) {
	        k++; 
	      }
	      if (k >= len) {
	        throw new TypeError('Reduce of empty array with no initial value');
	      }
	      value = t[k++];
	    }
	    for (; k < len; k++) {
	      if (k in t) {
	        value = callback(value, t[k], k, t);
	      }
	    }
	    return value;
	  };
	}
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map
	// Production steps of ECMA-262, Edition 5, 15.4.4.19
	// Reference: http://es5.github.io/#x15.4.4.19
	if (!Array.prototype.map) {
	  Array.prototype.map = <any>function Array_map(callback:Function, thisArg:any) {
	    var T:any, A:any, k:any;
	    if (this === null) {
	      throw new TypeError(' this is null or not defined');
	    }

	    // 1. Let O be the result of calling ToObject passing the |this| 
	    //    value as the argument.
	    var O = Object(this);

	    // 2. Let lenValue be the result of calling the Get internal 
	    //    method of O with the argument "length".
	    // 3. Let len be ToUint32(lenValue).
	    var len = O.length >>> 0;

	    // 4. If IsCallable(callback) is false, throw a TypeError exception.
	    // See: http://es5.github.com/#x9.11
	    if (typeof callback !== 'function') {
	      throw new TypeError(callback + ' is not a function');
	    }

	    // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
	    if (arguments.length > 1) {
	      T = thisArg;
	    }

	    // 6. Let A be a new array created as if by the expression new Array(len) 
	    //    where Array is the standard built-in constructor with that name and 
	    //    len is the value of len.
	    A = new Array(len);

	    // 7. Let k be 0
	    k = 0;

	    // 8. Repeat, while k < len
	    while (k < len) {

	      var kValue:any, mappedValue:any;

	      // a. Let Pk be ToString(k).
	      //   This is implicit for LHS operands of the in operator
	      // b. Let kPresent be the result of calling the HasProperty internal 
	      //    method of O with argument Pk.
	      //   This step can be combined with c
	      // c. If kPresent is true, then
	      if (k in O) {

	        // i. Let kValue be the result of calling the Get internal 
	        //    method of O with argument Pk.
	        kValue = O[k];

	        // ii. Let mappedValue be the result of calling the Call internal 
	        //     method of callback with T as the this value and argument 
	        //     list containing kValue, k, and O.
	        mappedValue = callback.call(T, kValue, k, O);

	        // iii. Call the DefineOwnProperty internal method of A with arguments
	        // Pk, Property Descriptor
	        // { Value: mappedValue,
	        //   Writable: true,
	        //   Enumerable: true,
	        //   Configurable: true },
	        // and false.

	        // In browsers that support Object.defineProperty, use the following:
	        // Object.defineProperty(A, k, {
	        //   value: mappedValue,
	        //   writable: true,
	        //   enumerable: true,
	        //   configurable: true
	        // });

	        // For best browser support, use the following:
	        A[k] = mappedValue;
	      }
	      // d. Increase k by 1.
	      k++;
	    }

	    // 9. return A
	    return A;
	  };
	}
}

function initSocialInfo():void {
	interface SocialStatInfo {
		project:string,
		site:string,
		uid:string
	}
	interface Social {
    	config: {
    		stat: SocialStatInfo
    	}
    }

    let social = (<any>window).social as Social;
    if (!social || !social.config || !social.config.stat) {
    	return;
    }
    let statInfo = social.config.stat;
    let info = PlatformDescriber.getInfo();
	info.sns = statInfo.site;
	info.userId = statInfo.uid;
	info.project = statInfo.project;
}

